function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import useEvent from "rc-util/es/hooks/useEvent";
import raf from "rc-util/es/raf";
import showWaveEffect from './WaveEffect';
import { ConfigContext } from '../../config-provider';
import useToken from '../../theme/useToken';
import { TARGET_CLS } from './interface';
export default function useWave(nodeRef, className, component) {
  var _React$useContext = React.useContext(ConfigContext),
      wave = _React$useContext.wave;

  var _useToken = useToken(),
      _useToken2 = _slicedToArray(_useToken, 3),
      token = _useToken2[1],
      hashId = _useToken2[2];

  var showWave = useEvent(function (event) {
    var node = nodeRef.current;

    if ((wave === null || wave === void 0 ? void 0 : wave.disabled) || !node) {
      return;
    }

    var targetNode = node.querySelector(".".concat(TARGET_CLS)) || node;

    var _ref = wave || {},
        showEffect = _ref.showEffect; // Customize wave effect


    (showEffect || showWaveEffect)(targetNode, {
      className: className,
      token: token,
      component: component,
      event: event,
      hashId: hashId
    });
  });
  var rafId = React.useRef(); // Merge trigger event into one for each frame

  var showDebounceWave = function showDebounceWave(event) {
    raf.cancel(rafId.current);
    rafId.current = raf(function () {
      showWave(event);
    });
  };

  return showDebounceWave;
}